var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPraharUnselected = function SvgPraharUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prahar-unselected_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.007 20v-3.75c0-10-7.5-15-7.5-15s2.5 3.75-5 7.5C31.006 12.5 31.006 20 31.006 20l9.996-2.127L51.007 20Z",
    fill: "url(#prahar-unselected_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.931 18.788-2.65-2.65c-7.076-7.075-15.914-5.3-15.914-5.3s4.426.887 1.763 8.837c-2.65 7.95 2.65 13.263 2.65 13.263l5.666-8.398 8.473-5.74.012-.012Z",
    fill: "url(#prahar-unselected_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.005 30h-3.75c-10 0-15.001 7.5-15.001 7.5s3.75-2.5 7.5 5S21.005 50 21.005 50l-2.226-9.905L21.005 30Z",
    fill: "url(#prahar-unselected_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.793 47.075-2.65 2.65c-7.076 7.075-5.3 15.912-5.3 15.912s.887-4.425 8.837-1.762c7.95 2.65 13.264-2.65 13.264-2.65l-8.5-6.685-5.639-7.453-.012-.012Z",
    fill: "url(#prahar-unselected_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.006 60v3.75c0 10 7.5 15 7.5 15s-2.5-3.75 5-7.5C51.008 67.5 51.008 60 51.008 60l-10.005 2.317L31.006 60Z",
    fill: "url(#prahar-unselected_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.082 61.212 2.65 2.65c7.076 7.075 15.914 5.3 15.914 5.3s-4.425-.887-1.763-8.837c2.65-7.95-2.65-13.263-2.65-13.263l-6.785 8.589-7.353 5.549-.013.012Z",
    fill: "url(#prahar-unselected_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.008 50h3.75c10.001 0 15.001-7.5 15.001-7.5s-3.75 2.5-7.5-5-11.25-7.5-11.25-7.5l2.217 10.095L61.008 50Z",
    fill: "url(#prahar-unselected_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.22 32.925 2.65-2.65c7.076-7.075 5.301-15.912 5.301-15.912s-.887 4.425-8.838 1.762c-7.95-2.65-13.263 2.65-13.263 2.65l8.49 6.876 5.648 7.262.013.012Z",
    fill: "url(#prahar-unselected_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.007 62.5c12.427 0 22.501-10.074 22.501-22.5S53.434 17.5 41.007 17.5c-12.428 0-22.502 10.074-22.502 22.5S28.58 62.5 41.007 62.5Z",
    fill: "url(#prahar-unselected_svg__j)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prahar-unselected_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -17.7778 29.4986 0 24.334 66.762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prahar-unselected_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-8.88962 -9.99995 18.6852 -16.6105 44.336 70.095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prahar-unselected_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.4455 0 0 33.6791 52.114 53.428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prahar-unselected_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-39.47 96.988 -50.684) scale(24.4707 52.0229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prahar-unselected_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 22.5 -22.5016 0 41.007 40)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prahar-unselected_svg__b",
    x1: 35.446,
    y1: 10.095,
    x2: 51.002,
    y2: 20.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prahar-unselected_svg__c",
    x1: 16.557,
    y1: 24.54,
    x2: 36.558,
    y2: 17.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prahar-unselected_svg__d",
    x1: 13.223,
    y1: 46.762,
    x2: 22.111,
    y2: 35.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prahar-unselected_svg__i",
    x1: 55.449,
    y1: 15.65,
    x2: 69.893,
    y2: 35.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prahar-unselected_svg__a",
    x: 0.254,
    y: 0.25,
    width: 81.506,
    height: 81.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5875_19624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5875_19624",
    result: "shape"
  })))));
};
export default SvgPraharUnselected;